<template>
  <div class="BasicTable">
    <vxe-table
      :data="tableData"
      border
      resizable
      show-header-overflow
      ref="xTable"
      :height="tableHeight"
      @cell-dblclick="celldblclick"
      @resizable-change="resizablechange"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold',zIndex:'2001'}"
    >
      <vxe-table-column type="index" align="center" width="60" fixed="left">
        <template v-slot:header="{ column }">
          <i :class="isInners" @click="clickIcon" style="color:#2594ff;font-size:18px"></i>
        </template>
        <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
      </vxe-table-column>
      <vxe-table-column width="150" align="center" title="操作" fixed="left">
        <template v-slot="{row,rowIndex}">
          <el-button @click="handleClick(row)" type="text" size="mini">修改</el-button>
          <el-button deleteClick @click="deleteClick(row)" type="text" size="mini">删除</el-button>
          <el-button
            id="btn"
            deleteClick
            @click="Discontinuation(row,rowIndex)"
            type="text"
            size="mini"
            v-if="StopedNameIfShow"
          >{{row.StopedName != "停用" ? "停用" : "启用"}}</el-button>
          <!-- ||ifshowsss -->
          <el-button v-if="!StopedNameIfShow" id="btn" deleteClick type="text" size="mini">
            <el-dropdown trigger="click" class="clearfix">
              <el-button type="text" size="mini">更多</el-button>
              <el-dropdown-menu slot="dropdown" @click="asdfgh(row)">
                <el-dropdown-item class="clearfix">
                  <el-button
                    id="btn"
                    deleteClick
                    @click="Discontinuation(row,rowIndex)"
                    type="text"
                    size="mini"
                  >{{row.StopedName != "停用" ? "停用" : "启用"}}</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="mini"
                    @click="constraintclick(row,rowIndex)"
                    :disabled="row.HandCheck==0?false:true"
                  >绑定</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="mini"
                    @click="deleteClickS(row,rowIndex)"
                    :disabled="row.HandCheck==1?false:true"
                  >解绑</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button type="text" size="mini" @click="Relieveclick(row,rowIndex)">设置</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-button>
        </template>
      </vxe-table-column>
      <template v-for="(item,index) in ObtainHeader">
        <vxe-table-column
          v-if="item.Key!='IsDir'"
          align="center"
          :width="item.Width==''?'200':item.Width"
          :key="index"
          :field="item.Key"
          :title="item.Rename"
        ></vxe-table-column>
        <vxe-table-column
          v-else
          align="center"
          :width="item.Width==''?'200':item.Width"
          :key="index"
          :field="item.Key"
          :title="item.Rename"
        >
          <template v-slot="{row}">
            <i v-if="row.IsDir" class="el-icon-tickets" style="color:#e9cb70;font-size:18px"></i>
            <i v-if="!row.IsDir" class="el-icon-folder" style="color:#e9cb70;font-size:18px"></i>
          </template>
        </vxe-table-column>
      </template>
    </vxe-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20,50,100]"
      :page-size="pageSizes"
      layout="total, sizes,prev, pager, next, jumper"
      :total="totals"
    ></el-pagination>
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
export default {
  data() {
    return {
      loading: false,
      data: this.tableData,
      BasicTabletree: true,
      header: this.headername,
      defaultProps: {
        children: "children",
        label: "label"
      },
      tableHeight: window.innerHeight - 300 + "px", // "400px",
      isInner: this.isInners, // 设置图标
      tableHeader: this.ObtainHeader,
      currentPage: this.currentPages, //当前页码
      total: this.totals, //总页数
      pageSize: this.pageSizes, //每页显示数量
      StopedNameIfShow: this.StopedNameifshow, //是否显示更多
      ifshowsss: this.ifshowss // 是否显示停用
    };
  },
  props: {
    // 是否显示停用
    ifshowss: {
      type: Boolean,
      default: false
    },
    // 是否显示更多
    StopedNameifshow: {
      type: Boolean,
      default: true
    },
    currentPages: Number, //当前页码
    totals: Number, //总页数
    pageSizes: Number, //每页显示数量
    tableData: Array, //表体数据
    ObtainHeader: Array, //表头数据
    headername: {
      type: String,
      default: "分类"
    },
    isInners: String, //设置图标
    IsDirShow: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    tableData: {
      handler(e, v) {
        if (e.length != 0) {
          this.data = e;
          this.loadList();
        }
      }
    },
    ObtainHeader: {
      handler(e, v) {
        if (e.length != 0) {
          this.tableHeader = e;
        }
      }
    }
  },
  methods: {
    // 设置
    Relieveclick(data, index) {
      this.$emit("Relieveclick", data, index);
    },
    // 绑定
    constraintclick(data, index) {
      this.$emit("constraintclick", data, index);
    },
    // 修改
    handleClick(obj) {
      this.$emit("handleClick", obj);
    },
    // 删除
    deleteClick(index) {
      this.$emit("deleteClick", index);
    },
    //停用
    Discontinuation(data, index) {
      this.$emit("Discontinuation", data, index);
    },
    // 分页
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    // 点击设置
    clickIcon() {
      this.$emit("clickIcon");
    },
    // 双击单元格
    celldblclick({ row }) {
      this.$emit("dblclick", row);
    },
    // 拖动列宽
    resizablechange({ $columnIndex, column }) {
      if ($columnIndex - 2 > 0 || $columnIndex == 2) {
        let jparams = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          Model: this.$attrs.pargam.Model,
          data: [
            {
              BaseNo: this.ObtainHeader[$columnIndex - 2].BaseNo,
              Width: column.resizeWidth
            }
          ]
        };
        this.request
          .post("/index/Settings/modify_function_fields", {
            jparams: JSON.stringify(jparams)
          })
          .then(res => {})
          .catch(err => {
            console.log(err);
          });
      }
    },
    loadList(size) {
      // this.loading = true;
      // setTimeout(() => {
      //   let xTable = this.$refs.xTable;
      //   if (xTable) {
      //     // 使用函数式加载，阻断 vue 对大数组的双向绑定，大数据性能翻倍提升
      //     xTable.reloadData(this.data).then(() => {
      //       this.loading = false;
      //     });
      //   } else {
      //     this.loading = false;
      //   }
      // }, 300);
    }
  },
  created() {
    this.loadList();
  },
  mounted() {},
  //
  watch: {
    tableData: {
      handler(newValue, oldValue) {
        this.loadList();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
  padding: 0 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/BasicTable/BasicTable.vue